var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "mail-message" } },
    [
      _c(
        "div",
        { staticClass: "sc-message--text", on: { click: _vm.openModal } },
        [
          _c("span", { staticClass: "material-icons mail-icon" }, [
            _vm._v("mail"),
          ]),
          _vm._v(" "),
          _c("span", [
            _c("span", { staticClass: "subject" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.message.raw.mail.subject) +
                  "\n            "
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "info",
                style: {
                  width:
                    _vm.message.raw.mail.body_text.length > 30 ? "26%" : "",
                },
              },
              [
                _c("span", {
                  staticClass: "content",
                  domProps: {
                    innerHTML: _vm._s(_vm.message.raw.mail.body_html),
                  },
                }),
              ]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.visitorDetailPopup && _vm.visible
        ? _c("VisitorDetailPopup", { attrs: { visibleMail: true } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }